import { ApolloError, gql, useMutation } from "@apollo/client";
import React from "react";
import {
  CrGoodInput,
  CrGoodMutation,
  CrGoodMutationVariables,
} from "../generated/graphql";

export interface ICrGoodFormProps {
  corporationIds?: number[];
  discountRate?: number;
  expirydate?: any;
  limitNumOrders?: number;
  price?: number;
  status: string;
  summary?: string;
  tags?: any[];
  title: string;
  weight?: number;
  related: number;
  subCategory?: {
    value: string;
    label: string;
  };
}

const CR_GOOD_MUTATION = gql`
  mutation crGood($input: CrGoodInput!) {
    crGood(input: $input) {
      ok
      err
      createdId
    }
  }
`;

export const useCrGood = (
  onCompleted?: (data: CrGoodMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<CrGoodMutation, CrGoodMutationVariables>(
    CR_GOOD_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};
